import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ResizeColumnDirective } from './directives/resize-column.directive';
import { DateMaskDirective } from '../core/directives/date-mask.directive';

@NgModule({
  declarations: [
    ResizeColumnDirective
  ],
  imports: [
    CommonModule,
    DateMaskDirective
  ],
  exports: [
    MatCardModule,
    MatToolbarModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatTabsModule,
    MatRadioModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatDividerModule,
    MatListModule,
    MatDialogModule,
    MatSortModule,
    MatChipsModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    ResizeColumnDirective,
    DateMaskDirective,
  ],
})
export class MaterialModule { }
